<template>
    <div class="text-center py-3">
        <user-call-avatar v-if="callTarget" :standardMap="callTarget" />

        <b-alert show variant="warning" class="mt-3 mb-0">
            {{ createError }}
        </b-alert>

        <div v-if="cooldownActive" class="retry-progress-track">
            <div class="retry-progress-bar" />
        </div>

        <div class="d-flex justify-content-center call-error-buttons mt-3">
            <b-btn
                @click="close"
                data-testid="call-error-close"
                variant="light"
                pill
            >
                {{ $t("Close") }}
            </b-btn>
            <b-btn
                v-if="callTarget"
                @click="tryAgain"
                data-testid="call-error-try-again"
                :disabled="creatingCall || cooldownActive"
                variant="primary"
                pill
            >
                {{ $t("Try Again") }}
            </b-btn>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

import UserCallAvatar from "@/components/user/UserCallAvatar";

const RETRY_COOLDOWN_MS = 5000;

export default {
    data() {
        return {
            cooldownActive: false,
            cooldownTimeout: null,
        };
    },
    computed: {
        ...mapState("call", ["createError", "callTarget", "creatingCall"]),
    },
    mounted() {
        this.startCooldown();
    },
    beforeDestroy() {
        if (this.cooldownTimeout) {
            clearTimeout(this.cooldownTimeout);
        }
    },
    methods: {
        startCooldown() {
            this.cooldownActive = true;
            this.cooldownTimeout = setTimeout(() => {
                this.cooldownActive = false;
                this.cooldownTimeout = null;
            }, RETRY_COOLDOWN_MS);
        },
        tryAgain() {
            this.$store.dispatch("call/tryAgain");
        },
        close() {
            this.$store.dispatch("call/close");
        },
    },
    components: {
        UserCallAvatar,
    },
};
</script>

<style scoped>
.call-error-buttons {
    gap: 0.75rem;
}

.retry-progress-track {
    height: 3px;
    width: 100%;
    background: rgba(0, 0, 0, 0.08);
    overflow: hidden;
    border-radius: 2px;
    margin-top: 0.5rem;
}

.retry-progress-bar {
    height: 100%;
    width: 100%;
    background: var(--primary);
    transform-origin: left center;
    animation: retry-progress-shrink 5s linear forwards;
}

@keyframes retry-progress-shrink {
    from {
        transform: scaleX(1);
    }
    to {
        transform: scaleX(0);
    }
}
</style>
